import { Badge, Box, Code, Group, Text } from '@mantine/core';
import CopyableValue from 'src/secret-menu/conversation-debugger/CopyableValue';
import { prettyJson, ToolCall } from 'src/secret-menu/conversation-debugger/types';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export default function ToolCallCard({ toolCall }: { toolCall: ToolCall }) {
  return (
    <Box p="xs" style={{ border: '1px solid var(--mantine-color-teal-2)', borderRadius: 8 }}>
      <Group gap="xs" mb={6} wrap="nowrap">
        <Badge size="xs" color="teal" variant="light">
          tool call
        </Badge>
        <Text size="textXs" fw={FONT_WEIGHTS.semibold} c="teal.7">
          {toolCall.function.name}
        </Text>
        <CopyableValue value={toolCall.id} />
      </Group>
      <Code block style={{ fontSize: 11, maxHeight: 300, overflow: 'auto' }}>
        {prettyJson(toolCall.function.arguments)}
      </Code>
    </Box>
  );
}
